<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { storeArticle, storeMyArticles } from "../scripts/blog";
    import { storeLanguage, lang_fr } from "../scripts/store";
    import { incrementRate, requestPublication } from '../scripts/apiArticles';
    import { addNotificationInfo }  from "../scripts/toaster";
    import { redirectTo } from '../scripts/router1';
    import { idPageArticleEdition, idPageMyArticles } from '../scripts/router2';
    import PopUp from '../components/PopUp.svelte';

    const websiteUrl = new URL(window.location.href).href;
    let unique = {}; // every {} is unique, {} === {} evaluates to false
    let showPopup = false;

    onMount(async () => {
        window.scrollTo(0,0);
        if ($storeArticle.id_article_status == 3) {
            incrementRate($storeArticle.id);
        }
	});

    function publication() {
        requestPublication($storeArticle.id);
        storeMyArticles.set([]);
        if ($storeLanguage == $lang_fr) {
            addNotificationInfo("Votre demande de publication a été envoyée. <br>Elle sera traitée dans les plus brefs délais.");
        } else {
            addNotificationInfo("Your publication request has been sent. <br>It will be processed as soon as possible.");
        };
        setTimeout(() => {
            redirectTo(idPageMyArticles)
        }, 2000);
    }

    function share() {
        navigator.clipboard.writeText(websiteUrl);
        reloadPopUp();
    }

    function reloadPopUp() {
        unique = {};
        showPopup = true;
    }

</script>
    
<style lang="scss">

    .article {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 50px 0 0 0;
        }
        &__header {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__intro {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__photo {
            object-fit: cover;
            object-position: 50% 0;
            border-radius: 20px 20px 20px 20px;
            width: 100%;            
        }
        &__subtitle {
            margin: 10px 0 10px 0;
        }
        &__date {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }
        &__rate {
            width: 100%;
            &__img {
                width: 20px;
                margin: 0 10px 0 10px;
            }
        }
        &__update {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            margin: 10px 0 10px 0;
        }
        &__text {
            width: 100%;
            margin: 30px 0 30px 0;
            :global(h1) {
                font-weight: 700;
                color: $color_text;
                font-size: 36px;
                text-transform: uppercase;
            }
            :global(h2) {
                font-size: 24px;
                font-weight: 900;
                letter-spacing: 0px;
            }
            :global(h3) {
                font-size: 22px;
                font-weight: 600;
            }
            :global(h4) {
                font-weight: 600;
            }
        }
        
        &__share {
            margin: 30px 0 0 15px;
            width: 30px;
            height: 30px;
            &__copied {
                position: absolute;
                margin-top: -60px;
            }
        }

    }

    @include large {
        .article {
            &__header {
                width: 100%;
                display: grid;
                grid-template-columns: 50% 50%;
                gap: 30px;
                justify-content: flex-start;
            }
            &__intro {
                align-items: flex-start;
            }
            &__update {
                width: 50%;
            }
            &__share {
                cursor: pointer;
                transition: all 0.5s;
                &:hover {
                    transform: scale(1.2);
                }
            }
        }
    }

</style>

<div class="article">
    <PageHeader props="Article"/>
    <div class="bloc article__bloc">
        <div class="article__header">
            {#if ($storeArticle.photo != undefined && $storeArticle.photo != "")}
            <img class="article__photo" src="../assets/images/articles/{$storeArticle.id}_{$storeArticle.photo}" alt="article">
            {/if}
            <div class="article__intro">
                <div class="article__title font__h2">
                    {$storeArticle.title_fr}
                </div>
                <div class="article__subtitle font__h4">
                    {$storeArticle.subtitle_fr}
                </div>    
                <div class="article__date">
                    {#if ($storeLanguage == $lang_fr)}
                    Le {$storeArticle.date_publication} par {$storeArticle.author.first_name} {$storeArticle.author.last_name}
                    {:else}
                    On {$storeArticle.date_publication} by {$storeArticle.author.first_name} {$storeArticle.author.last_name}
                    {/if}
                    <img class="article__rate__img" src="../assets/images/vue.png" alt="view">{$storeArticle.rate}
                </div>
                {#if ($storeArticle.id_article_status == 3)}
                    <div>
                    {#if ($storeLanguage == $lang_fr)}
                        <img  class="article__share" src="../assets/images/share.png" alt="share" title="Partagez moi !" on:click={() => share()} on:keydown={() => share()}/>
                        <div class="article__share__copied">
                            {#key unique}
                            <PopUp props={{isDisplayed: showPopup, message: "copié !"}} />
                            {/key}    
                        </div>
                    {:else}
                        <img  class="article__share" src="../assets/images/share.png" alt="share" title="Share me!" on:click={() => share()} on:keydown={() => share()}/>
                        <div class="article__share__copied">
                            {#key unique}
                            <PopUp props={{isDisplayed: showPopup, message: "copied!"}} />
                            {/key}    
                        </div>
                    {/if}
                    </div>
                {/if}
                {#if ($storeArticle.id_article_status == 1)}
                <div class="article__update">
                    {#if ($storeLanguage == $lang_fr)}
                    <input class="button" type="submit" on:click={() => redirectTo(idPageArticleEdition, "?id="+$storeArticle.id)} value="Modifier">
                    <input class="button" type="submit" on:click={publication} value="Demander la publication">
                    {:else}
                    <input class="button" type="submit" on:click={() => redirectTo(idPageArticleEdition, "?id="+$storeArticle.id)} value="Edit">
                    <input class="button" type="submit" on:click={publication} value="Request publication">
                    {/if}
                </div>
                {/if}
            </div>
        </div>
        <div class="article__text">
            {@html $storeArticle.text_fr}
        </div>
    </div>
</div>
